import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'two-factor-setup',
        loadChildren: () => import('./two-factor-setup/two-factor-setup.module').then((m) => m.TwoFactorSetupModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'users',
        loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'profile-questions',
        loadChildren: () =>
          import('./profile-questions/profile-questions.module').then((m) => m.ProfileQuestionsModule),
      },
      {
        path: 'dialogues',
        loadChildren: () => import('./dialogues/dialogues.module').then((m) => m.DialoguesModule),
      },
      {
        path: 'payouts',
        loadChildren: () => import('./payouts/payouts.module').then((m) => m.PayoutsModule),
      },
      {
        path: 'admin-users',
        loadChildren: () => import('./admin-users/admin-users.module').then((m) => m.AdminUsersModule),
      },
      {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
